<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Book Description</span></p>
<p class="P_WFP_BodyText"><i>Wild Blue U: Foundation of Honor—The Officer</i> continues the historical saga chronicling the United States Air Force Academy. <i>The Officer</i> unveils the arduous training of America’s leaders, showcasing empathetic, larger-than-life characters set against a fascinating tapestry of vivid, history-changing events that affect the course of the nation, ranging from cheating scandals at the USAF Academy to the Cuban missile crisis and the jungles of Vietnam.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?a219d434